__turbopack_context__.v({
  "accordionSlideOverwrite": "testimonials-module-scss-module__zk121G__accordionSlideOverwrite",
  "attribution": "testimonials-module-scss-module__zk121G__attribution",
  "carousel": "testimonials-module-scss-module__zk121G__carousel",
  "controls": "testimonials-module-scss-module__zk121G__controls",
  "ctaButton": "testimonials-module-scss-module__zk121G__ctaButton",
  "divider": "testimonials-module-scss-module__zk121G__divider",
  "fadeIn": "testimonials-module-scss-module__zk121G__fadeIn",
  "fadeOut": "testimonials-module-scss-module__zk121G__fadeOut",
  "name": "testimonials-module-scss-module__zk121G__name",
  "quote": "testimonials-module-scss-module__zk121G__quote",
  "scaleIn": "testimonials-module-scss-module__zk121G__scaleIn",
  "scaleOut": "testimonials-module-scss-module__zk121G__scaleOut",
  "slide": "testimonials-module-scss-module__zk121G__slide",
  "testimonials": "testimonials-module-scss-module__zk121G__testimonials",
  "title": "testimonials-module-scss-module__zk121G__title",
  "viewport": "testimonials-module-scss-module__zk121G__viewport",
  "zoomIn": "testimonials-module-scss-module__zk121G__zoomIn",
  "zoomOut": "testimonials-module-scss-module__zk121G__zoomOut",
});
